import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ScheduleTermList } from './interface/term-interface';

@Injectable()
export class TermService {
    constructor(private http: HttpClient) {}

    //sort roster
    getNonScheduleTerm(): Observable<ScheduleTermList> {
        return this.http.get<ScheduleTermList>('/term/noScheduleTerm', {});
    }

    getCurrentTerm(): Observable<any> {
        return this.http.get<any>('/api/term/current', {});
    }

    getNextTerm(): Observable<any> {
        return this.http.get<any>('/api/term/next', {});
    }

    getPreviousTerm(): Observable<any> {
        return this.http.get<any>('/api/term/previous', {});
    }
}
